import { css as k, LitElement as w, html as a, nothing as u } from "lit";
import { property as l, state as y, customElement as E } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b as I } from "./styles-scZ6dVz-.js";
import { b as c, a as g } from "./events-CkEPl0SM.js";
var C = Object.defineProperty, A = Object.getOwnPropertyDescriptor, n = (e, t, r, s) => {
  for (var d = s > 1 ? void 0 : s ? A(t, r) : t, h = e.length - 1, p; h >= 0; h--)
    (p = e[h]) && (d = (s ? p(t, r, d) : p(d)) || d);
  return s && d && C(t, r, d), d;
};
let i = class extends w {
  constructor() {
    super(...arguments), this.nodes = [], this.expandedIds = [], this.showLines = !1, this.checkable = !1, this.checkedIds = [], this.expandAll = !1, this.internalExpandedIds = /* @__PURE__ */ new Set();
  }
  connectedCallback() {
    super.connectedCallback(), this.expandAll ? this.expandAllNodes(this.nodes) : this.internalExpandedIds = new Set(this.expandedIds);
  }
  updated(e) {
    e.has("expandedIds") && (this.internalExpandedIds = new Set(this.expandedIds)), e.has("expandAll") && this.expandAll && this.expandAllNodes(this.nodes);
  }
  expandAllNodes(e) {
    for (const t of e)
      t.children && t.children.length > 0 && (this.internalExpandedIds.add(t.id), this.expandAllNodes(t.children));
  }
  isExpanded(e) {
    return this.internalExpandedIds.has(e);
  }
  isChecked(e) {
    return this.checkedIds.includes(e);
  }
  toggleExpand(e, t) {
    t.stopPropagation(), this.isExpanded(e.id) ? (this.internalExpandedIds.delete(e.id), c(this, g.COLLAPSE, { node: e, id: e.id })) : (this.internalExpandedIds.add(e.id), c(this, g.EXPAND, { node: e, id: e.id })), this.requestUpdate();
  }
  selectNode(e) {
    e.disabled || (this.selectedId = e.id, c(this, g.SELECT, { node: e, id: e.id, data: e.data }));
  }
  toggleCheck(e, t) {
    if (t.stopPropagation(), e.disabled) return;
    const r = this.isChecked(e.id);
    r ? this.checkedIds = this.checkedIds.filter((s) => s !== e.id) : this.checkedIds = [...this.checkedIds, e.id], c(this, "ark-check", {
      node: e,
      id: e.id,
      checked: !r,
      checkedIds: this.checkedIds
    });
  }
  handleKeydown(e, t) {
    switch (t.key) {
      case "Enter":
      case " ":
        t.preventDefault(), this.selectNode(e);
        break;
      case "ArrowRight":
        e.children && e.children.length > 0 && (t.preventDefault(), this.isExpanded(e.id) || (this.internalExpandedIds.add(e.id), this.requestUpdate(), c(this, g.EXPAND, { node: e, id: e.id })));
        break;
      case "ArrowLeft":
        e.children && e.children.length > 0 && this.isExpanded(e.id) && (t.preventDefault(), this.internalExpandedIds.delete(e.id), this.requestUpdate(), c(this, g.COLLAPSE, { node: e, id: e.id }));
        break;
    }
  }
  renderNode(e, t = 0) {
    const r = e.children && e.children.length > 0, s = this.isExpanded(e.id), d = this.selectedId === e.id, h = this.isChecked(e.id), p = {
      "node-content": !0,
      selected: d && !this.checkable,
      disabled: e.disabled ?? !1
    }, x = {
      toggle: !0,
      expanded: s
    }, v = a`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 18 6-6-6-6"/>
      </svg>
    `, b = a`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"/>
      </svg>
    `, m = a`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
        <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
      </svg>
    `;
    return a`
      <li part="node" class="node" role="treeitem" aria-expanded=${r ? s : u}>
        <div
          part="content"
          class=${f(p)}
          tabindex="0"
          @click=${() => this.selectNode(e)}
          @keydown=${(o) => this.handleKeydown(e, o)}
        >
          ${r ? a`
                <button
                  part="toggle"
                  class=${f(x)}
                  type="button"
                  aria-label=${s ? "Collapse" : "Expand"}
                  @click=${(o) => this.toggleExpand(e, o)}
                >
                  ${v}
                </button>
              ` : a`<span class="toggle-placeholder"></span>`}

          ${this.checkable ? a`
                <span class="checkbox-container">
                  <input
                    type="checkbox"
                    class="checkbox"
                    .checked=${h}
                    ?disabled=${e.disabled}
                    @click=${(o) => this.toggleCheck(e, o)}
                  />
                </span>
              ` : u}

          <span part="icon" class="icon">
            ${r ? b : m}
          </span>

          <span part="label" class="label">${e.label}</span>
        </div>

        ${r ? a`
              <div class="children ${s ? "expanded" : ""}">
                <div class="children-inner">
                  <ul class="node-list nested" role="group">
                    ${e.children.map((o) => this.renderNode(o, t + 1))}
                  </ul>
                </div>
              </div>
            ` : u}
      </li>
    `;
  }
  render() {
    const e = {
      tree: !0,
      "show-lines": this.showLines
    };
    return a`
      <div part="tree" class=${f(e)} role="tree">
        <ul class="node-list">
          ${this.nodes.map((t) => this.renderNode(t))}
        </ul>
      </div>
    `;
  }
};
i.styles = [
  I,
  k`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .tree {
        font-family: var(--r5-font-body);
        font-size: var(--r5-text-sm);
        color: var(--r5-text);
      }

      .node-list {
        list-style: none;
        margin: 0;
        padding: 0;
      }

      .node-list.nested {
        padding-left: var(--r5-space-5);
      }

      .node {
        user-select: none;
      }

      .node-content {
        display: flex;
        align-items: center;
        gap: var(--r5-space-1);
        padding: var(--r5-space-1) var(--r5-space-2);
        border-radius: var(--r5-radius-md);
        cursor: pointer;
        transition: background-color var(--r5-duration-fast) var(--r5-ease-default);
      }

      .node-content:hover {
        background-color: var(--r5-bg-muted);
      }

      .node-content:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: -2px;
      }

      .node-content.selected {
        background-color: var(--r5-color-primary-100);
        color: var(--r5-color-primary-700);
      }

      .node-content.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.25rem;
        height: 1.25rem;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-sm);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .toggle:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .toggle svg {
        width: 0.875rem;
        height: 0.875rem;
        transition: transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .toggle.expanded svg {
        transform: rotate(90deg);
      }

      .toggle-placeholder {
        width: 1.25rem;
        height: 1.25rem;
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
        color: var(--r5-text-muted);
      }

      .icon svg {
        width: 100%;
        height: 100%;
      }

      .label {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      /* Children container with animation */
      .children {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows var(--r5-duration-normal) var(--r5-ease-default);
      }

      .children.expanded {
        grid-template-rows: 1fr;
      }

      .children-inner {
        overflow: hidden;
      }

      /* Connecting lines */
      .show-lines .node-list.nested {
        position: relative;
      }

      .show-lines .node-list.nested::before {
        content: '';
        position: absolute;
        left: 0.625rem;
        top: 0;
        bottom: 0.75rem;
        width: 1px;
        background-color: var(--r5-border);
      }

      .show-lines .nested .node-content::before {
        content: '';
        position: absolute;
        left: -0.875rem;
        width: 0.5rem;
        height: 1px;
        background-color: var(--r5-border);
      }

      .show-lines .nested .node {
        position: relative;
      }

      /* Checkbox mode */
      .checkbox-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
      }

      .checkbox {
        width: 1rem;
        height: 1rem;
        margin: 0;
        cursor: pointer;
        accent-color: var(--r5-color-primary-500);
      }

      @media (prefers-reduced-motion: reduce) {
        .toggle svg,
        .children {
          transition: none;
        }
      }
    `
];
n([
  l({ type: Array })
], i.prototype, "nodes", 2);
n([
  l({ type: String, attribute: "selected-id" })
], i.prototype, "selectedId", 2);
n([
  l({ type: Array, attribute: "expanded-ids" })
], i.prototype, "expandedIds", 2);
n([
  l({ type: Boolean, attribute: "show-lines" })
], i.prototype, "showLines", 2);
n([
  l({ type: Boolean, attribute: "checkable" })
], i.prototype, "checkable", 2);
n([
  l({ type: Array, attribute: "checked-ids" })
], i.prototype, "checkedIds", 2);
n([
  l({ type: Boolean, attribute: "expand-all" })
], i.prototype, "expandAll", 2);
n([
  y()
], i.prototype, "internalExpandedIds", 2);
i = n([
  E("ark-tree")
], i);
export {
  i as A
};
//# sourceMappingURL=ark-tree-BwcmcYJG.js.map
